export default __webpack_public_path__ + "static/media/carDoors.e525890e.svg";